import { useAuth0 } from '@auth0/auth0-react';
import { CSSProperties } from 'react';

const AuthButtons: React.FC = () => {
    const { loginWithRedirect } = useAuth0();

    const handleLogin = async (): Promise<void> => {
        try {
            await loginWithRedirect();
        } catch (error) {
            console.error('TheMousy Web - Login error:', error);
        }
    };

    const handleSignup = async (): Promise<void> => {
        try {
            await loginWithRedirect({
                authorizationParams: {
                    screen_hint: 'signup'
                }
            });
        } catch (error) {
            console.error('TheMousy Web - Signup error:', error);
        }
    };

    const handlePasskeyLogin = async (): Promise<void> => {
        try {
            await loginWithRedirect({
                authorizationParams: {
                    connection: 'webauthn', // Make sure this matches your WebAuthn connection name
                    prompt: 'login'
                }
            });
        } catch (error) {
            console.error('TheMousy Web - Passkey login error:', error);
        }
    };

    const containerStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px'
    };

    const buttonStyle: CSSProperties = {
        padding: '15px 30px',
        fontSize: '18px',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s',
        minWidth: '220px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    };

    const passkeyButtonStyle: CSSProperties = {
        ...buttonStyle,
        backgroundColor: '#6f42c1',
        color: 'white'
    };

    const loginButtonStyle: CSSProperties = {
        ...buttonStyle,
        backgroundColor: '#007bff',
        color: 'white'
    };

    const signupButtonStyle: CSSProperties = {
        ...buttonStyle,
        backgroundColor: '#28a745',
        color: 'white'
    };

    return (
        <div style={containerStyle}>
            <h2 style={{ marginBottom: '20px', color: '#333' }}>
                Welcome to TheMousy! 🐭
            </h2>

            {/* Passkey Login - Primary Option */}
            <button
                onClick={handlePasskeyLogin}
                style={passkeyButtonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#5a2d91';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(111,66,193,0.3)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#6f42c1';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
            >
                🔐 Sign in with Passkey
            </button>

            <div style={{ fontSize: '12px', color: '#666', margin: '10px 0' }}>
                — or —
            </div>

            {/* Regular Login/Signup Buttons */}
            <button
                onClick={handleLogin}
                style={loginButtonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#0056b3';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,123,255,0.3)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#007bff';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
            >
                🔑 Log In to TheMousy
            </button>

            <button
                onClick={handleSignup}
                style={signupButtonStyle}
                onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = '#218838';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 8px rgba(40,167,69,0.3)';
                }}
                onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = '#28a745';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                }}
            >
                🎯 Sign Up for TheMousy
            </button>

            <div style={{
                fontSize: '14px',
                color: '#666',
                textAlign: 'center',
                marginTop: '15px',
                maxWidth: '350px',
                lineHeight: '1.4'
            }}>
                <strong>🔐 Passkey:</strong> Use fingerprint, face, or PIN for secure access<br/>
                <strong>🔑 Log In:</strong> Existing users with email/password<br/>
                <strong>🎯 Sign Up:</strong> New to TheMousy? Create your account
            </div>
        </div>
    );
};

export default AuthButtons;